import mixpanel from 'mixpanel-browser';

const TOKEN = process.env.NEXT_PUBLIC_MIXPANEL_TOKEN ?? '';

let initialized = false;

export function initMixpanel(): void {
  if (typeof window === 'undefined' || !TOKEN || initialized) return;
  mixpanel.init(TOKEN, {
    debug: process.env.NODE_ENV === 'development',
    track_pageview: false,
    persistence: 'localStorage',
    autocapture: true,
    // Session Replay (record_sessions_percent) drži mutex u localStorage; u dev/Strict Mode/HMR
    // često javlja "[lock] Timeout waiting for mutex". Snimanje sesija uključite u Mixpanel
    // dashboardu ako vam treba, ili ovde sa niskim npr. 1 umesto 100.
  });
  initialized = true;
}

export function mixpanelIdentify(
  userId: string,
  props?: { $email?: string; $name?: string },
): void {
  if (!TOKEN) return;
  initMixpanel();
  mixpanel.identify(userId);
  if (props && (props.$email || props.$name)) {
    mixpanel.people.set({
      ...(props.$email ? { $email: props.$email } : {}),
      ...(props.$name ? { $name: props.$name } : {}),
    });
  }
}

export function mixpanelReset(): void {
  if (!TOKEN) return;
  initMixpanel();
  mixpanel.reset();
}

export function trackPageView(props: {
  page_url: string;
  page_title: string;
  user_id?: string;
}): void {
  if (!TOKEN) return;
  initMixpanel();
  mixpanel.track('Page View', {
    page_url: props.page_url,
    page_title: props.page_title,
    ...(props.user_id ? { user_id: props.user_id } : {}),
  });
}

export function trackSignIn(props: {
  user_id?: string;
  login_method: string;
  success: boolean;
}): void {
  if (!TOKEN) return;
  initMixpanel();
  mixpanel.track('Sign In', {
    login_method: props.login_method,
    success: props.success,
    ...(props.user_id ? { user_id: props.user_id } : {}),
  });
}

export function trackSignUp(props: {
  user_id: string;
  email: string;
  signup_method: string;
  utm_source?: string;
  utm_medium?: string;
  utm_campaign?: string;
}): void {
  if (!TOKEN) return;
  initMixpanel();
  mixpanel.track('Sign Up', props);
}

export function trackSearch(props: {
  search_query: string;
  user_id?: string;
  results_count: number;
}): void {
  if (!TOKEN) return;
  initMixpanel();
  mixpanel.track('Search', props);
}

export function trackError(props: {
  error_type: string;
  error_message: string;
  error_code?: string;
  page_url?: string;
  user_id?: string;
}): void {
  if (!TOKEN) return;
  initMixpanel();
  mixpanel.track('Error', props);
}
